import React, { ReactElement, ReactNode } from 'react';
import { Box } from '@material-ui/core';

export interface ICardTemplateContainerProps {
	columns: number;
	children?: ReactNode;
	className?: string;
}

export function CardTemplateContainer(
	props: ICardTemplateContainerProps
): ReactElement {
	const { columns, children, className } = props;

	function getGridTemplateColumns(): string {
		let templateColumns: string[] = [];
		for (let index: number = 0; index < columns; index++) {
			templateColumns.push('1fr');
		}
		return templateColumns.join(' ');
	}

	return (
		<Box
			className={`map-card-container ${className || ''}`}
			display="grid"
			gridGap="2.4rem"
			gridTemplateColumns={getGridTemplateColumns()}
		>
			{children}
		</Box>
	);
}
